import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TextListItem from '@rotaready/frecl/build/TextListItem';
import UL from '@rotaready/frecl/build/UL';

import { ViewportBreakpoints } from '../cssConstants';

const Container = styled.div`
  margin-bottom: 40px;

  > ul > li {
    padding: 15px;
    margin: 0;
  }

  @media (min-width: ${ViewportBreakpoints.tabletPortraitUpper}) {
    > ul {
      columns: ${props => props.columns};

      > li {
        padding: 20px 40px 20px 0;
      }
    }
  }
`;

const CheckmarkIcon = styled(FontAwesomeIcon).attrs({
  icon: ['fal', 'check'],
})`
  color: ${({ theme: { colors } }) => colors.brand};
`;

const CheckmarkTextList = ({ items, columns }) => (
  <Container columns={columns}>
    <UL size="md" uistyle="normal" icon={(<CheckmarkIcon />)}>
      {items.map((text, index) => (
        /* eslint-disable-next-line react/no-array-index-key */
        <TextListItem text={text} key={index} />
      ))}
    </UL>
  </Container>
);

CheckmarkTextList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
  columns: PropTypes.number,
};

CheckmarkTextList.defaultProps = {
  items: [],
  columns: 2,
};

export default CheckmarkTextList;
